/** -----枚举----- */
// 缴费方式
export const methodEnum = {
  SCENE: '水厂',
  WECHAT: '微信',
  BALANCE: '余额'
};

// 操作类型
export const statusEnum = {
  PAY: '缴费',
  RECHARGE: '充值'
};


/** -----select选项----- */
export const methodOptions = [
  {
    label: '水厂',
    value: 'SCENE'
  },
  {
    label: '微信',
    value: 'WECHAT'
  },
  {
    label: '余额',
    value: 'BALANCE'
  }
];

export const statusOptions = [
  {
    label: '缴费',
    value: 'PAY'
  },
  {
    label: '充值',
    value: 'RECHARGE'
  }
];




// WEBPACK FOOTER //
// ./src/assets/js/common.js